export default (locale) => {
  const protocol = process.env.IS_SERVER ? 'http' : process.env.REACT_APP_PROTOCOL
  const hostname = process.env.IS_SERVER ? 'proxy' : process.env.REACT_APP_HOST_NAME
  return `${protocol}://${hostname}${locale ? `/${locale}` : ''}/graphql`
}


// WEBPACK FOOTER //
// ./src/utils/getGraphqlURI.js